export const registerUserForm = {
    email: '',
    password: '',
    acceptRuleRegister: false
};
export const errorRegisterUser = {
    email: '',
    password: '',
    acceptRuleRegister: ''
};
